import "./styles.css";
import { BeadHomecomingApp } from "./app";

const root = document.querySelector<HTMLElement>("#app");
if (!root) {
  throw new Error("Missing #app root");
}

new BeadHomecomingApp(root).start();
